export default __webpack_public_path__ + "static/media/location--white.1a9383aa.svg";